module.exports = __webpack_public_path__ + "img/blip-logo.04e4c824.png";